"use client";

import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/lib/utils";

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "flex h-10 w-full min-w-0 flex-nowrap items-center justify-start overflow-x-auto overscroll-x-contain rounded-[var(--fx-r-md)] bg-[var(--fx-paper-2)] p-1 pe-2 text-[var(--fx-ink-500)] dark:bg-[var(--dk-surface2)] dark:text-[var(--dk-text-soft)] fx-scroll-hidden",
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-[var(--fx-r-sm)] px-3 py-1.5 text-sm font-medium transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fx-accent-500)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-[var(--fx-ink-900)] data-[state=active]:text-[var(--fx-paper)] data-[state=active]:shadow-sm dark:data-[state=active]:bg-[var(--fx-paper)] dark:data-[state=active]:text-[var(--fx-ink-900)] data-[state=inactive]:hover:bg-[var(--fx-s-raised-hover)] data-[state=inactive]:hover:text-[var(--fx-ink-900)] dark:data-[state=inactive]:hover:bg-[var(--fx-s-raised-hover)] dark:data-[state=inactive]:hover:text-[var(--dk-text)]",
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
